import { createClient, SupabaseClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || window.location.origin;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

// Create a mock client if no anon key (dev without supabase)
let supabase: SupabaseClient;

if (!supabaseAnonKey) {
  console.warn('VITE_SUPABASE_ANON_KEY not set - auth features disabled');
  // Create client anyway - it will fail on auth calls but won't crash the app
  supabase = createClient(supabaseUrl, 'placeholder-key-for-dev', {
    auth: {
      autoRefreshToken: false,
      persistSession: false,
    },
  });
} else {
  supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      storage: window.localStorage,
    },
  });
}

export { supabase };
